export default {
  type: 'spring',
  stiffness: 800,
  damping: 60,
};
